import React from "react";
import { Globe, Printer, Puzzle, TabletSmartphone } from "lucide-react";
import { Translate } from "components/common/Translate/Translate";
import {ISection8UseCase, Section8UseCaseScaffold} from "components/features/CompressorCommon/Section8UseCaseScaffold";

const bestUseList: ISection8UseCase[] = [
    {
        title: "Perfect-Social-Media-Thumbnails-heading",
        subTitle: "Perfect-Social-Media-Thumbnails-sub-heading",
        icon: <Globe strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "Spot-On-Images-for-Your-Online-Store-heading",
        subTitle: "Spot-On-Images-for-Your-Online-Store-sub-heading",
        icon: <Puzzle />,
    },
    {
        title: "Sleek-Presentation-Graphics-heading",
        subTitle: "Sleek-Presentation-Graphics-sub-heading",
        icon: <TabletSmartphone />,
    },
    {
        title: "Polished-Brand-Assets-for-Your-Website-heading",
        subTitle: "Polished-Brand-Assets-for-Your-Website-sub-heading",
        icon: <Printer />,
    },
];
const PngResizerUseCase = () => {
    return (
        <Section8UseCaseScaffold
            title={<Translate keyName="best-usage-online-tool-title" />}
            useCases={bestUseList}
        />
    );
};

export default PngResizerUseCase;
